import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

export default function GoogleAutoAuth() {
  const { isGuest, loginWithGoogle } = useAuth();
  const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID || '194102935146-hjbhf90jhc6o79i2qognfb8mgi1q08q5.apps.googleusercontent.com';

  useEffect(() => {
    if (!isGuest) return;

    // Clear Google One Tap cooldown cookie so prompt shows every time on guest visit
    try {
      document.cookie = "g_state=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      document.cookie = "g_state=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=" + window.location.hostname;
    } catch {}

    window.handleGoogleOneTapCallback = async (response) => {
      if (!response?.credential) return;
      const toastId = toast.loading('Signing in with Google...');
      try {
        const user = await loginWithGoogle(response.credential);
        toast.success(`Welcome ${user?.name || 'User'}! Signed in with Google.`, { id: toastId });
      } catch (err) {
        console.error('Google One-Tap auth failed:', err);
        toast.error('Google Sign-In failed', { id: toastId });
      }
    };

    const triggerAndroidNativeAuth = () => {
      if (window.ShopAxoBridge?.triggerGoogleSignIn) {
        console.log('[GoogleAutoAuth] Triggering Android Native Google Sign-In');
        window.ShopAxoBridge.triggerGoogleSignIn();
        return true;
      }
      return false;
    };

    if (triggerAndroidNativeAuth()) return;

    const bridgeCheckInterval = setInterval(() => {
      if (triggerAndroidNativeAuth()) {
        clearInterval(bridgeCheckInterval);
      }
    }, 300);

    const bridgeCheckTimeout = setTimeout(() => {
      clearInterval(bridgeCheckInterval);
    }, 3000);

    const triggerPrompt = () => {
      if (window.google?.accounts?.id) {
        try {
          window.google.accounts.id.cancel();
          window.google.accounts.id.initialize({
            client_id: clientId,
            callback: window.handleGoogleOneTapCallback,
            auto_select: false,
            cancel_on_tap_outside: false
          });
          window.google.accounts.id.prompt((notification) => {
            if (notification.isNotDisplayed()) {
              console.log('[GoogleOneTap] Reason not displayed:', notification.getNotDisplayedReason());
            } else if (notification.isSkippedMoment()) {
              console.log('[GoogleOneTap] Reason skipped:', notification.getSkippedReason());
            }
          });
        } catch (e) {
          console.error('[GoogleOneTap] Failed to initialize prompt:', e);
        }
      }
    };

    triggerPrompt();
    const interval = setInterval(triggerPrompt, 800);
    const timeout = setTimeout(() => clearInterval(interval), 4000);

    return () => {
      clearInterval(bridgeCheckInterval);
      clearTimeout(bridgeCheckTimeout);
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [isGuest, loginWithGoogle, clientId]);

  if (!isGuest) return null;

  return (
    <div 
      id="g_id_onload"
      data-client_id={clientId}
      data-callback="handleGoogleOneTapCallback"
      data-auto_prompt="true"
      data-cancel_on_tap_outside="false"
    />
  );
}
